import { AuthenticationService } from 'src/app/core/auth/authentication.service';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { map, filter, mergeMap } from 'rxjs/operators';
import { LS_LANG, DEFAULT_LANG } from './core/utils/constants';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'CarpetaV2angular';

  constructor(
    private translate: TranslateService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService) {

    /** Establecemos el idioma. Lo buscamos en el localstorage y si no está asignamos el de por defecto */
    let lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    translate.setDefaultLang(lang);
    translate.use(lang);

    /** Registramos los iconos de la aplicación */
    iconRegistry.addSvgIcon('add', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/add.svg'));
    iconRegistry.addSvgIcon('alarm', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/alarm.svg'));
    iconRegistry.addSvgIcon('arrow_down', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/arrow_down.svg'));
    iconRegistry.addSvgIcon('bar_chart', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/bar_chart.svg'));
    iconRegistry.addSvgIcon('bomb', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/bomb.svg'));
    iconRegistry.addSvgIcon('cached', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/cached.svg'));
    iconRegistry.addSvgIcon('calendar', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/calendar.svg'));
    iconRegistry.addSvgIcon('car', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/car.svg'));
    iconRegistry.addSvgIcon('caret_abajo', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/caret_abajo.svg'));
    iconRegistry.addSvgIcon('checked', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/checked.svg'));
    iconRegistry.addSvgIcon('right', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/circle_right.svg'));
    iconRegistry.addSvgIcon('clapping', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/clapping.svg'));
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/close.svg'));
    iconRegistry.addSvgIcon('comentarios', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/comentarios.svg'));
    iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/delete.svg'));
    iconRegistry.addSvgIcon('document', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/document.svg'));
    iconRegistry.addSvgIcon('done', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/done.svg'));
    iconRegistry.addSvgIcon('down_carpeta', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/down_carpeta.svg'));
    iconRegistry.addSvgIcon('down', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/down.svg'));
    iconRegistry.addSvgIcon('edit_externa', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/edit_externa.svg'));
    iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/edit.svg'));
    iconRegistry.addSvgIcon('exclamation', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/exclamation.svg'));
    iconRegistry.addSvgIcon('eye', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/eye.svg'));
    iconRegistry.addSvgIcon('file_text', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/file_text.svg'));
    iconRegistry.addSvgIcon('file', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/file.svg'));
    iconRegistry.addSvgIcon('folder', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/folder.svg'));
    iconRegistry.addSvgIcon('forbidden', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/forbidden.svg'));
    iconRegistry.addSvgIcon('home', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/home.svg'));
    iconRegistry.addSvgIcon('hotel', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/hotel.svg'));
    iconRegistry.addSvgIcon('info', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/info.svg'));
    iconRegistry.addSvgIcon('information', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/information.svg'));
    iconRegistry.addSvgIcon('menu', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/menu.svg'));
    iconRegistry.addSvgIcon('mobile_alt', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/mobile_alt.svg'));
    iconRegistry.addSvgIcon('open_folder', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/open_folder.svg'));
    iconRegistry.addSvgIcon('paper_plane', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/paper_plane.svg'));
    iconRegistry.addSvgIcon('password', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/password.svg'));
    iconRegistry.addSvgIcon('pdf', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/pdf.svg'));
    iconRegistry.addSvgIcon('permissions', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/permissions.svg'));
    iconRegistry.addSvgIcon('reorder', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/reorder.svg'));
    iconRegistry.addSvgIcon('return', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/return.svg'));
    iconRegistry.addSvgIcon('save', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/save.svg'));
    iconRegistry.addSvgIcon('search_externa', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/search_externa.svg'));
    iconRegistry.addSvgIcon('search', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/search.svg'));
    iconRegistry.addSvgIcon('send', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/send.svg'));
    iconRegistry.addSvgIcon('settings_power', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings_power.svg'));
    iconRegistry.addSvgIcon('signature', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/signature.svg'));
    iconRegistry.addSvgIcon('swipe', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/swipe.svg'));
    iconRegistry.addSvgIcon('tutorial', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/tutorial.svg'));
    iconRegistry.addSvgIcon('unlink', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/unlink.svg'));
    iconRegistry.addSvgIcon('up', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/up.svg'));
    iconRegistry.addSvgIcon('user', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/user.svg'));
    iconRegistry.addSvgIcon('zoom', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/zoom.svg'));
    iconRegistry.addSvgIcon('requisitos', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/requisitos.svg'));
    iconRegistry.addSvgIcon('phone', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/phone.svg'));
  }

  ngOnInit() {
    console.log("app.component.ngOnInit()");
    this.authService.retrieveUser();
    //Le colocamos el title a cada página
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => { console.log(route.data); return route.data })
    ).subscribe((event) => {
      this.translate.get(event['pageTitle']).subscribe((res: string) => {
        this.titleService.setTitle(res);
      });
    });
  }
}
